import React, { useState, useEffect, useRef } from "react";
import "../Styles/CreateNewClient.css";
import logo from "../assests/images/menubar_logo.png";
import BackgroundInfoSection from "./BackgroundInfoSection";
import AddFamilyMemeberForClient from "./AddFamilyMemeberForClient";
import EducationWorkForm from "./EducationWorkForm";
import PhysicalAttributesForm from "./PhysicalAttributesForm";
import PhotographUploader from "./PhotographUploader";
import LifestyleAndInterests from "./LifestyleAndInterests";
import VideoAndDocumentsUploader from "./VideoAndDocumentsUploader";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  PROFILE_LOGIN,
  USER_ID,
} from "../utils/store-data-constants";
import { getData, saveData } from "../utils/store-data";
import Select from "react-select";
import {
  check_phone_no,
  create_profile,
  get_castes,
  get_communities,
  get_country_states,
  get_district_cities,
  get_habits,
  get_hobbies,
  get_language,
  get_marital_status,
  get_physical_build,
  get_qualification,
  get_religios,
  get_skin_tone,
  get_state_districts,
  update_client_photo,
  update_profile_photo,
  update_profile_video,
  get_relations,
  edit_profile,
  get_profile_byid,
  get_client_relations,
  create_client,
  get_level1_caste,
  get_level3_caste,
  get_level2_caste,
  get_country_list,
  get_cities,
  get_states,
  get_all_countries,
  get_client,
  update_profile_document,
  get_commmunity_docs,
} from "../api/serverWrapper";
import { log_debug, log_info } from "../utils/log";
import UserInfo from "../components/UserInfo";
import Profile from "../components/Profile";
import { useNavigate } from "react-router-dom";
import ClientPreferences from "./ClientPreferences";
import Address from "../components/Address";
import ClientInviteCard from "./ClientInviteCard";
import UserSystemRole from "../components/UserSystemRole";
import AddFamilyWealthForClient from "./AddFamilyWealthForClient";
import { customStyles } from "../utils/commonFunctions";
import DobWheelPicker from "../components/DobWheelPicker";
import { useMasterData } from "../context/MasterDataContext";
import { validateUploadSelection } from "../utils/uploadLimits";
import {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
  validatePhoneNumberLength,
} from "libphonenumber-js";

export default function CreateNewClientForProfile() {
  const {
    religionMasterData,
    countryMasterData,
    allCasteMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    communityMasterData,
    languageMasterData,
    relationsMasterData,
    clientRelationsMasterData,
    communityDocsMasterData,
    allCountyMasterData,
  } = useMasterData();
  const Father = 1;
  const Mother = 2;

  let [userIdForProfile, setUserIdForProfile] = useState(null);
  let [profileId, setProfileId] = useState(null);
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const createProfileLock = useRef(false);
  const preferencesSaveRef = useRef(null);
  const [savedPhone, setSavedPhone] = useState("");

  const handleNextStep = async () => {
    if (createProfileLock.current) return;
    if (currentStep === 1) {
      if (profileId) {
        // Profile already created earlier — don't re-run create/duplicate-phone check.
        // Any edits made here will be picked up and saved when EditProfile() runs at step 2.
        setCurrentStep((prev) => prev + 1);
      } else {
        CreateProfile();
      }
    }
    if (currentStep === 2) {
      await EditProfile();
    }

    if (currentStep === 3) {
      setBtnLoading(true);
      try {
        const preferencesSaved = await preferencesSaveRef.current?.();
        if (!preferencesSaved) return;

        setCurrentStep((prev) => prev + 1);
        navigate("/dashboard", { replace: true });
      } finally {
        setBtnLoading(false);
      }
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentStep]);

  const [btnLoading, setBtnLoading] = useState(false);

  let [profileData, setProfileData] = useState(new Profile());
  let [userData, setUserData] = useState(new UserInfo());
  let [UserDataMatchPrep, setUserDataMatchPrep] = useState(null);
  const [accessOnRequest, setAccessOnRequest] = useState(false);

  const [countryCode, setCountryCode] = useState(""); // e.g. "IN"
  const [states, setStates] = useState([]);
  const [communitieDocs, setCommuniteDocs] = useState(
    communityDocsMasterData || [],
  );
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [phno, setPhno] = useState("");

  const [error, setError] = useState("");

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");

    setPhno(value);

    const code = countries.find((id) => id.value === countryCode)?.phoneCode;

    if (!code) {
      setError("");
      return;
    }

    const fullPhoneNumber = `+${code}${value}`;

    const lengthError = validatePhoneNumberLength(fullPhoneNumber);

    // Don't show an error while the user is still typing
    if (lengthError === "TOO_SHORT") {
      setError("");
      return;
    }

    if (lengthError === "TOO_LONG" || lengthError === "INVALID_LENGTH") {
      setError("Enter a valid contact number");
      return;
    }

    if (!isPossiblePhoneNumber(fullPhoneNumber)) {
      setError("Enter a valid contact number");
    } else {
      setError("");
    }
  };
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [collageName, setCollageName] = useState("");
  const [jobRole, setJobRole] = useState("");

  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [desc, setDesc] = useState("");
  const [Salary, setSalary] = useState("");
  const [salaryCurrency, setSalaryCurrency] = useState("");
  const [carrerGoals, setcarrerGoals] = useState("");

  const [familyDetails, setFamilyDetails] = useState([
    { RelationshipId: 1, FamilyMemberName: "", Occupation: "", RoleDesc: "" }, // Father
    { RelationshipId: 2, FamilyMemberName: "", Occupation: "", RoleDesc: "" }, // Mother
  ]);

  const [familyWealth, setFamilyWealth] = useState([]);

  const [languages, setLanguage] = useState(languageMasterData || []);
  const [selectedLanguage, setSelectedLanguage] = useState([]);

  const [selectedRelation, setSelectedRelation] = useState("");
  const [selectedQualification, setSelectedQualification] = useState("");
  const [selectedGender, setSelectedGender] = useState(false);
  let [cleintGender, setClientGender] = useState(1);

  const handleQualificationDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedQualification(id);
  };

  const handleGenderDataFromChild = (e) => {
    const id = Number(e.target.value);
    setSelectedGender(id);
    setSelectedRelation(id === 1 ? 2 : id === 2 ? 1 : "");
  };

  const handleClientRelations = (e) => {
    const id = Number(e.target.value);
    setSelectedRelationFrClient(id);
  };

  let [UserId, setUserId] = useState(null);
  const [religion, setReligion] = useState(religionMasterData || []);
  const [relationsForClient, setRelationsForClients] = useState([]);
  const [selectedRelationFrClient, setSelectedRelationFrClient] = useState("");
  const [countryList, setCountryList] = useState(countryMasterData || []);

  const [level1Caste, setLevel1Caste] = useState([]);
  const [level2Caste, setLevel2Caste] = useState([]);
  const [level3Caste, setLevel3Caste] = useState([]);
  const [communityList, setCommunity] = useState(communityMasterData || []);
  const [maritalStatus, setMaritalStatus] = useState(
    maritalStatusMasterData || [],
  );
  const [skinToneList, setSkinToneList] = useState(skinToneMasterData || []);
  const [physicalbuildList, setPhysicalBuildList] = useState(
    buildMasterData || [],
  );
  const [habitList, setHabitList] = useState(habitsMasterData || []);
  const [hobbiesList, setHobbiesList] = useState(hobbiesMasterData || []);
  const [qualifications, setQualifications] = useState(
    qualificationMasterData || [],
  );
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedResidence, setSelectedResidence] = useState("");
  const [selectedCitizenship, setSelectedCitizenship] = useState("");
  const [seletedEthinicity, setSelectedEthinicity] = useState("");
  const [postalcode, setPostalCode] = useState("");

  let [selectedReligion, setSelectedReligion] = useState("");

  let [selectedCaste, setSelectedCaste] = useState("");
  const [selectedCommunities, setSelectedCommunities] = useState("");
  const [selectedLevel2Caste, setSelectedLevel2Caste] = useState("");
  const [selectedLevel3Caste, setSelectedLevel3Caste] = useState("");
  const [selectedMaritalStatus, setSelectedMaritalStatus] = useState("");
  const [selectedSkinTone, setSelectedSkinTone] = useState(null);
  const [selectedBuild, setSelectedBuild] = useState(null);
  const [selectedHabit, setSelectedHabit] = useState([]);
  const [selectedHobbies, setSelectedHobbie] = useState([]);

  let [selectedDate, setSelectedDate] = useState("");
  const [limitSameReligion, setLimitSameReligion] = useState(false);
  const [limitSameCaste, setLimitSameCaste] = useState(false);
  const [limitSameSubCaste, setLimitSameSubCaste] = useState(false);
  const [limitSameSubCommunity, setLimitSameSubCommunity] = useState(false);
  const [limitLanguage, setLimitLanguage] = useState(false);
  let [parentID, setParentId] = useState(null);
  const [docFile, setDocFile] = useState(null);
  const [docName, setDocName] = useState("");
  const [mainIndex, setMainIndex] = useState(0);
  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      let id = await getData(USER_ID);
      UserId = id;
      setUserId(UserId);
      let resp = await get_client(id);
      console.log(resp.data);
      parentID = resp.data.ParentId || null;
      setParentId(parentID);
      cleintGender = resp.data.Gender;
      setClientGender(cleintGender);
      await fetchCountries();

      let filteredRelations = clientRelationsMasterData || [];

      if (parentID === Father || parentID === Mother) {
        const parentName = `${resp.data.FirstName || ""} ${
          resp.data.LastName || ""
        }`;

        // console.log(parentName, resp.data.FirstName);

        setFamilyDetails((prev) => {
          // check if parent relationship already exists
          const index = prev.findIndex(
            (item) => item.RelationshipId === parentID,
          );

          // if exists → update name
          if (index !== -1) {
            const updated = [...prev];
            updated[index] = {
              ...updated[index],
              FamilyMemberName: parentName,
            };
            return updated;
          }

          // if not exists → insert new object
          return [
            ...prev,
            {
              RelationshipId: parentID,
              FamilyMemberName: parentName,
              Occupation: "",
              RoleDesc: "",
            },
          ];
        });
      }

      if (parentID) {
        filteredRelations = filteredRelations.filter((item) => item.id !== 1);
      } else {
        // filteredRelations = filteredRelations.filter((item) =>
        //   [1, 4, 5, 8].includes(item.id),
        // );
        filteredRelations = filteredRelations;
      }

      console.log(filteredRelations);
      setRelationsForClients(filteredRelations);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchCountries = async () => {
  //   try {
  //     // const res = await get_all_countries(); // replace with your endpoint
  //     const data = allCountyMasterData;

  //     if (data) {
  //       const formatted = data.map((c) => {
  //         const code = c.phonecode.startsWith("+")
  //           ? c.phonecode
  //           : `+${c.phonecode}`;
  //         return {
  //           value: c.isoCode,
  //           label: `${c.name} (${code})`,
  //           name: c.name,
  //           phoneCode: c.phonecode,
  //         };
  //       });
  //       console.log("formatted get_all_countries", formatted);
  //       setCountries(formatted);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching countries", err);
  //   }
  // };
  const fetchCountries = async () => {
    try {
      const data = allCountyMasterData;

      if (data) {
        const formatted = data.flatMap((c) => {
          const phonecode = c.phonecode?.toString() || "";

          // Split:
          // "+1-809 and 1-829"
          // into:
          // ["+1-809", "1-829"]
          const phoneCodes = phonecode
            .split(/\s+and\s+/i)
            .map((code) => code.trim())
            .filter(Boolean);

          return phoneCodes.map((fullCode) => {
            // For display:
            // "+1-809" -> "+1"
            // "1-829"  -> "+1"
            const countryCode = fullCode.split("-")[0];

            const displayCode = countryCode.startsWith("+")
              ? countryCode
              : `+${countryCode}`;

            return {
              // ORIGINAL COMPLETE CODE -> backend
              value: c.isoCode,

              // ONLY COUNTRY CODE -> display
              label: `${c.name} (${displayCode})`,

              name: c.name,
              phoneCode: c.phonecode,
            };
          });
        });

        console.log("formatted countries", formatted);

        setCountries(formatted);
      }
    } catch (err) {
      console.error("Error fetching countries", err);
    }
  };
  useEffect(() => {
    console.log("Selectd countryCode", countryCode);

    if (countryCode) {
      (async () => {
        try {
          console.log("Selectd inside countryCode", countryCode);
          const res = await get_states(countryCode);
          if (res.success) {
            const formattedStates = res.data.map((s) => ({
              value: s.isoCode,
              label: s.name,
              countryCode: s.countryCode,
            }));
            console.log("formattedStates ", formattedStates);

            setStates(formattedStates);
            setSelectedState(null); // reset state
            setCities([]); // reset cities
          }
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      })();
    }
  }, [countryCode]);

  useEffect(() => {
    if (!countryCode || !allCountyMasterData?.length) return;

    const selectedCountry = allCountyMasterData.find(
      (c) => c.isoCode === countryCode,
    );

    if (selectedCountry?.currency) {
      setSalaryCurrency(selectedCountry.currency);
    }
  }, [countryCode, allCountyMasterData]);

  // 2️⃣ When state changes, fetch cities
  useEffect(() => {
    if (countryCode && selectedState) {
      (async () => {
        try {
          const res = await get_cities(countryCode, selectedState.value);
          if (res.success) {
            const formattedCities = res.data.map((c) => ({
              value: c.name,
              label: c.name,
              stateCode: c.stateCode,
              countryCode: c.countryCode,
            }));
            setCities(formattedCities);
            setSelectedCity(null);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      })();
    }
  }, [selectedState, countryCode]);

  const handleReligionDataFromChild = async (e) => {
    let id = Number(e.target.value);
    selectedReligion = id;
    setSelectedReligion(selectedReligion);
    // await getLevel1Castes(id);
    await getlevl2Caste(id, null);
  };

  const getlevl2Caste = async (selectedReligion, id) => {
    let data = await get_level2_caste(selectedReligion, id);
    console.log("get level2 caste", data);
    setLevel2Caste(data.data);
    setLevel3Caste([]);
    setSelectedLevel3Caste("");
  };

  const handlelevle2Caste = (e) => {
    let id = Number(e.target.value);
    setSelectedLevel2Caste(id);
    if (id) {
      getLevel3Caste(id);
    }
  };

  const getLevel3Caste = async (id) => {
    console.log(selectedCaste);

    let resp = await get_level3_caste(selectedCaste, id);
    setLevel3Caste(resp.data);
  };

  const handleLevel3Caste = (e) => {
    let id = Number(e.target.value);
    setSelectedLevel3Caste(id);
  };

  const handleMaritaStatusDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedMaritalStatus(id);
  };

  const handleCommunitiesDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedCommunities(id);
  };

  const handelDataFromSkinToneModal = (e) => {
    let id = Number(e.target.value);
    setSelectedSkinTone(id);
  };

  const handelDataFromBuildModal = (e) => {
    let id = Number(e.target.value);
    setSelectedBuild(id);
  };

  const [addresDet, setAddressDet] = useState("");

  const handelAddreesDet = (e) => {
    let text = e.target.value;
    setAddressDet(text);
    profileData.address.AddressDetails = text;
  };

  const handleResidence = (e) => {
    let val = e.target.value;
    setSelectedResidence(val);
  };

  const handleCitizenship = (e) => {
    let val = e.target.value;
    setSelectedCitizenship(val);
  };

  const handleEthinicity = (e) => {
    let val = e.target.value;
    setSelectedEthinicity(val);
  };

  const handlePostalcode = (e) => {
    let val = e.target.value;
    setPostalCode(val);
  };

  const checkPhoneNumber = async (phno) => {
    if (profileId && phno === savedPhone) return true; // unchanged — already registered to this profile
    let resp = await check_phone_no(phno);
    return resp.success;
  };

  let [profileImages, setProfileImages] = useState([]);
  const [videoFile, setVideoFile] = useState(null);

  const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setProfileImages((prev) => [...prev, ...selectedFiles]);
  };

  const handleVideoChange = (e) => {
    setVideoFile(e.target.files[0]);
  };

  const uploadPhotos = async (id) => {
    if (profileImages.length === 0 && !videoFile) {
      alert("Please select images or a video to upload.");
      setBtnLoading(false);
      return false;
    }

    const validationError = await validateUploadSelection({
      photoFiles: profileImages,
      photoCount: profileImages.length,
      videoFile,
      documentFile: docFile,
    });
    if (validationError) {
      alert(validationError);
      return false;
    }

    setBtnLoading(true);

    try {
      // ✅ SELECTED MAIN IMAGE
      const mainFile = profileImages[mainIndex];

      if (mainFile) {
        const profilePhotoResponse = await update_profile_photo(id, mainFile);

        if (profilePhotoResponse.status !== 200) {
          alert("Profile photo upload failed.");
          return false;
        }
      }

      // ✅ ALL IMAGES
      if (profileImages.length > 0) {
        const clientPhotoResponse = await update_client_photo(
          id,
          profileImages,
        );

        if (clientPhotoResponse.status !== 200) {
          alert("Client photo upload failed.");
          return false;
        }
      }

      // VIDEO
      if (videoFile) {
        const videoResp = await update_profile_video(id, videoFile);

        if (videoResp.status !== 200) {
          alert("Video upload failed.");
          return false;
        }
      }

      // DOCUMENT
      if (docFile) {
        const doc = await update_profile_document(id, docFile, docName);

        if (doc.status !== 200) {
          alert("Document upload failed.");
          return false;
        }
      }

      showToast("Upload successful!");
      return true;
    } catch (error) {
      console.error("Error in uploadPhotos:", error);
      alert("An error occurred while uploading.");
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const renderRelations = () => {
    return maritalStatus.map((item, index) => (
      <option key={index} value={item.MarriageStatusId}>
        {item.MarriageStatus}
      </option>
    ));
  };
  const renderRelationsForClient = () => {
    return relationsForClient.map((item, index) => (
      <option key={index} value={item.id}>
        {item.RelationName}
      </option>
    ));
  };

  const renderReligion = () => {
    return religion.map((item, index) => (
      <option key={index} value={item.ReligionId}>
        {item.ReligionName}
      </option>
    ));
  };

  const renderLevel2Caste = () => {
    return level2Caste?.map((item, index) => (
      <option key={index} value={item.CasteL2Id}>
        {item.CasteName}
      </option>
    ));
  };
  const renderLevel3Caste = () => {
    return level3Caste?.map((item, index) => (
      <option key={index} value={item.CasteL3Id}>
        {item.CasteName}
      </option>
    ));
  };
  const renderLang = () => {
    return languages.map((item, index) => (
      <option key={index} value={item.LangId}>
        {item.LangDesc}
      </option>
    ));
  };

  const handleSelect = (e) => {
    const selectedId = Number(e.target.value);
    const lang = languages.find((l) => l.LangId === selectedId);
    if (!lang) return;

    setSelectedLanguage((prev) =>
      prev.some((c) => c.LangId === lang.LangId) ? prev : [...prev, lang],
    );
  };

  const removeLanguage = (langToRemove) => {
    setSelectedLanguage((prev) =>
      prev.filter((c) => c.LangId !== langToRemove.LangId),
    );
  };

  useEffect(() => {
    console.log("Selected Images:", profileImages);
  }, [profileImages]);

  const showToast = (message) => {
    const toast = document.getElementById("toast-message");
    if (!toast) return;

    toast.innerText = message;
    toast.style.display = "block";

    // Force reflow to restart animation
    void toast.offsetWidth;

    toast.style.animation = "fadeInOut 3s ease-in-out";

    // Hide again after animation
    setTimeout(() => {
      toast.style.display = "none";
    }, 3000);
  };

  const ValidateProfile = async () => {
    if (!selectedRelationFrClient) {
      showToast("Select a Relation to Create Profile");
      return false;
    }

    if (!selectedDate) {
      showToast("Enter the Date of Birth");
      return false;
    }

    if (!firstName) {
      showToast("Enter First Name");
      return false;
    }

    if (!lastName) {
      showToast("Enter Last Name");
      return false;
    }

    if (!countryCode) {
      showToast("Select Country");
      return false;
    }
    if (!selectedState) {
      showToast("Select State");
      return false;
    }
    if (!selectedCity) {
      showToast("Select City");
      return false;
    }
    // if (!selectedRelation) {
    //   showToast("Choose Relation with Bride / Groom");
    //   return false;
    // }

    if (!selectedGender) {
      showToast("Choose Gender");
      return false;
    }
    // if (phno) {
    //   if (phno.length !== 10) {
    //     showToast("Enter a valid 10-digit contact number");
    //     return false;
    //   }
    // }

    let code = countries.find((id) => id.value === countryCode)?.phoneCode;

    const fullPhoneNumber = `+${code}${phno}`;

    if (!isValidPhoneNumber(fullPhoneNumber)) {
      showToast("Enter a valid contact number");
      return false;
    }

    // if (!desc) {
    //   showToast("Enter Profile Description");
    //   return false;
    // }

    if (!selectedMaritalStatus) {
      showToast("Choose Relationship History");
      return false;
    }
    if (!selectedReligion) {
      showToast("Select Religion ");
      return false;
    }
    // if (!selectedCaste) {
    //   showToast("Select Caste");
    //   return false;
    // }
    if (!selectedLevel2Caste) {
      showToast("Select Caste");
      return false;
    }
    if (!selectedLevel3Caste) {
      showToast("Select Sub-Caste");
      return false;
    }
    if (selectedLanguage <= 0) {
      showToast("Choose Language");
      return false;
    }

    const result = await checkPhoneNumber(phno);
    if (!result) {
      showToast("User with this phone number already exists");
      return false;
    }

    return true;
  };

  const validateAdressAndSalary = () => {
    if (Salary) {
      if (!salaryCurrency) {
        showToast("Please Choose Salary currency Details");
        setBtnLoading(false);
        return false;
      }
    }

    if (!addresDet) {
      showToast("Enter Address Details");
      setBtnLoading(false);
      return false;
    }

    if (!selectedQualification) {
      showToast("Please Select  Qualification");
      setBtnLoading(false);
      return false;
    }
    if (!selectedCitizenship) {
      showToast("Choose  Citizenship");
      setBtnLoading(false);
      return false;
    }

    if (!height) {
      showToast("Choose height in feet");
      setBtnLoading(false);
      return false;
    }
    if (!weight) {
      showToast("Choose weight in Kg");
      setBtnLoading(false);
      return false;
    }

    if (profileImages.length === 0) {
      showToast("Please choose at least one profile image to proceed.");
      setBtnLoading(false);
      return;
    }

    return true;
  };

  async function getProfileByID(id) {
    let resp = await get_profile_byid(id);
    console.log("client main ", resp.data[0]);
    UserDataMatchPrep = resp?.data[0];
    setUserDataMatchPrep(UserDataMatchPrep);

    loadAddress(UserDataMatchPrep);
  }

  const loadAddress = (UserDataMatchPrep) => {
    let address = UserDataMatchPrep?.User?.Address;
    setAddressDet(address?.AddressDetails);
    profileData.address.AddressDetails = address?.AddressDetails;
    setSelectedResidence(address?.ResidenceId);
    setSelectedCitizenship(address?.CitizenshipId);
    setSelectedEthinicity(address?.Ethinicity);
    setPostalCode(address?.PostalCode);
  };
  const CreateProfile = async () => {
    if (createProfileLock.current) return;

    createProfileLock.current = true;
    setBtnLoading(true);

    try {
      if (!(await ValidateProfile())) {
        createProfileLock.current = false;
        setBtnLoading(false);
        return;
      }
      // if (!ValidateQualification()) return;
      // if (!ValidateBackgroundInfo()) return;
      // if (!validateAdress()) return;
      // if (!validatePhysicalAttribute()) return;
      // if (!validatePhoto()) return;
      userData.PhoneNumber = phno;
      userData.FirstName = firstName;
      userData.LastName = lastName;
      userData.FatherName = middleName;
      userData.DOB = selectedDate;
      userData.UserLanguage = selectedLanguage.map((lang) => lang.LangId);
      userData.SystemRole = UserSystemRole.PROFILE.id;
      userData.Gender = selectedGender;

      let code = countries.find((id) => id.value === countryCode)?.phoneCode;
      console.log(code);
      userData.CountyCode = code;

      profileData.ProfileDescription = desc;
      profileData.RelationId = selectedRelation;
      profileData.MarriageStatusId = selectedMaritalStatus;
      profileData.ReligionId = selectedReligion;
      profileData.CasteId = selectedCaste;
      profileData.CasteLevel2Id = selectedLevel2Caste;
      profileData.CasteLevel3Id = selectedLevel3Caste;
      profileData.CommunitiesId = selectedCommunities;
      profileData.Height = height;
      profileData.Weight = weight;
      profileData.QualificationId = selectedQualification;
      profileData.JobRole = jobRole;
      profileData.CollageName = collageName;
      profileData.BuildId = selectedBuild;
      profileData.SkinToneId = selectedSkinTone;
      profileData.ProfileHabits = selectedHabit.map((habit) => habit.HabitId);
      profileData.ProfileHobbies = selectedHobbies.map(
        (habit) => habit.HobbiesId,
      );
      if (Salary) {
        profileData.Salary = String(Salary);
      }
      profileData.familyDetails = familyDetails;
      // profileData.familyWealth = familyWealth;
      profileData.address.CountryId = countryCode;
      profileData.address.StateId = selectedState.value;
      profileData.address.CityId = selectedCity.value;
      profileData.ClientRelationId = selectedRelationFrClient;
      profileData.ClientId = UserId;

      profileData.LimitSameReligion = limitSameReligion;
      profileData.LimitSameCaste = limitSameCaste;
      profileData.LimitSameSubCaste = limitSameSubCaste;
      profileData.LimitSameSubCommunity = limitSameSubCommunity;
      profileData.LimitLanguage = limitLanguage;
      profileData.IsPhoneNumberOptional = true;

      // Remove empty values
      Object.keys(userData).forEach((key) => {
        if (!userData[key]) {
          delete userData[key];
        }
      });

      Object.keys(profileData).forEach((key) => {
        if (!profileData[key]) {
          delete profileData[key];
        }
      });

      if (!addresDet) {
        delete profileData.address.AddressDetails;
      }

      // ResidenceId
      if (!selectedResidence) {
        delete profileData.address.ResidenceId;
      }

      // CitizenshipId
      if (!selectedCitizenship) {
        delete profileData.address.CitizenshipId;
      }

      // Ethinicity
      if (!seletedEthinicity) {
        delete profileData.address.Ethinicity;
      }

      // if (Object.values(profileData.address || {}).some((val) => val === null)) {
      //   delete profileData.address;
      // }

      setUserData(userData);
      console.log("userData", userData);
      console.log(profileData);
      profileData.userInfo = userData;
      profileData.IsPhotoVisible = accessOnRequest;

      profileData.ClientRelationOwnerId = parentID ? parentID : cleintGender;
      setProfileData(profileData);

      console.log("profileData", profileData);

      // return;

      let resp = await create_profile(profileData);
      console.log(resp);

      if (resp.code === 200) {
        userIdForProfile = resp.data.User.UserId;
        setUserIdForProfile(userIdForProfile);
        profileId = resp.data.ProfileId;
        setProfileId(profileId);
        await getProfileByID(resp.data.ProfileId);
        setSavedPhone(phno);
        showToast("Profile Created successful!");
        setCurrentStep((prev) => prev + 1);
      } else if (resp.errorCode === "PHONE_ALREADY_EXISTS") {
        showToast("User with this phone number already exists");
      } else if (resp.errorCode === "ACTIVE_PROFILE_EXISTS") {
        showToast("User with this phone number already has an active profile");
      } else {
        alert("Profile not Created");
      }
    } catch (error) {
      console.log(error);
    } finally {
      createProfileLock.current = false;
      setBtnLoading(false);
    }
  };

  const EditProfile = async () => {
    if (btnLoading) return;
    setBtnLoading(true);
    // if (!ValidateQualification()) return;
    // if (!ValidateBackgroundInfo()) return;
    if (!validateAdressAndSalary()) return;
    // if (!validatePhysicalAttribute()) return;
    // if (!validatePhoto()) return;

    userData.PhoneNumber = phno;
    userData.FirstName = firstName;
    userData.LastName = lastName;
    userData.FatherName = middleName;
    userData.DOB = selectedDate;

    userData.UserId = userIdForProfile;

    if (selectedResidence) {
      profileData.address.ResidenceId = selectedResidence;
    } else {
      delete profileData.address.ResidenceId;
    }

    if (selectedCitizenship) {
      profileData.address.CitizenshipId = selectedCitizenship;
    } else {
      delete profileData.address.CitizenshipId;
    }

    if (seletedEthinicity) {
      profileData.address.Ethinicity = seletedEthinicity;
    } else {
      delete profileData.address.Ethinicity;
    }

    if (postalcode) {
      profileData.address.PostalCode = postalcode;
    } else {
      delete profileData.address.PostalCode;
    }

    // profileData.ProfileDescription = desc;
    // profileData.RelationId = selectedRelation;
    // profileData.MarriageStatusId = selectedMaritalStatus;
    // profileData.ReligionId = selectedReligion;
    // profileData.CasteId = selectedCaste;
    // profileData.CommunitiesId = selectedCommunities;
    profileData.Height = height;
    profileData.Weight = weight;
    profileData.QualificationId = selectedQualification;
    profileData.JobRole = jobRole;
    profileData.CollageName = collageName;
    profileData.BuildId = selectedBuild;
    profileData.SkinToneId = selectedSkinTone;
    profileData.ProfileHabits = selectedHabit;
    profileData.ProfileHobbies = selectedHobbies;
    if (Salary) {
      profileData.Salary = String(Salary);
    }
    profileData.SalaryCurrency = salaryCurrency;
    profileData.familyDetails = familyDetails;
    profileData.familyWealth = familyWealth;
    profileData.CarrerGoals = carrerGoals;
    delete profileData.address.CountryId;
    delete profileData.address.StateId;
    delete profileData.address.CityId;
    delete profileData.IsPhoneNumberOptional;
    profileData.ProfileId = profileId;

    // Remove empty values
    Object.keys(userData).forEach((key) => {
      if (!userData[key]) {
        delete userData[key];
      }
    });

    Object.keys(profileData).forEach((key) => {
      if (!profileData[key]) {
        delete profileData[key];
      }
    });

    // if (Object.values(profileData.address || {}).some((val) => val === null)) {
    //   delete profileData.address;
    // }

    setUserData(userData);
    console.log("userData", userData);
    console.log(profileData);
    profileData.userInfo = userData;
    profileData.IsPhotoVisible = accessOnRequest;

    delete profileData.AgentId;
    setProfileData(profileData);

    console.log("profileData", selectedHobbies, selectedHabit);

    try {
      let resp = await edit_profile(profileData);
      console.log("edit_profile", resp);

      if (resp.code === 200) {
        if (!(await uploadPhotos(resp.data.User.UserId))) return;
        await getProfileByID(resp.data.ProfileId);
        setCurrentStep((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  if (Loading) {
    <div className="loading-screen">
      <img src={logo} alt="Logo" className="logo-3d" />
    </div>;
  }

  return (
    <div className="main-new-client">
      {/* Fixed Header */}
      <header className="top-header">
        <div className="header-content">
          <img
            src={logo}
            alt="WedLuk Logo"
            className="logos"
            style={{ height: "60px", cursor: "pointer" }}
          />
          <span className="nav-item">Create new client profile</span>
        </div>
      </header>

      {/* Fixed Step Tabs */}
      <div className="step-tabs-container">
        <div className="step-tabs">
          <div
            className={`step-new-client  ${
              currentStep === 1
                ? "active"
                : currentStep === 2 || 3
                  ? "completed-task"
                  : ""
            }`}
          >
            Profile settings
          </div>
          <div className="connector" />
          <div
            className={`step-new-client  ${
              currentStep === 2
                ? "active"
                : currentStep === 3
                  ? "completed-task"
                  : ""
            }`}
          >
            Client information
          </div>
          <div className="connector" />
          <div
            className={`step-new-client  ${currentStep === 3 ? "active" : ""}`}
          >
            Client Preferences
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="create-client-container">
        {currentStep === 1 && (
          <div className="">
            <div className="card-new-client">
              <div className="lable2-for-new-client mt-1">
                Select a Relation to Create Profile *
              </div>
              <div className="form-group-new-client">
                <select
                  required
                  value={selectedRelationFrClient}
                  onChange={handleClientRelations}
                >
                  <option>Select a Relation to Create Profile</option>
                  {renderRelationsForClient()}
                </select>
              </div>
            </div>

            <div className="card-new-client">
              <h2 className="section-title-for-new-client">Profile Settings</h2>
              <div className="lable2-for-new-client">
                Enter Groom/Bride Name *
              </div>
              <div className="d-flex justify-content-between">
                <div className="form-group-new-client w-50 me-2">
                  <input
                    type="text"
                    placeholder=" First Name"
                    value={firstName}
                    required
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div className="form-group-new-client w-50 ms-2">
                  <input
                    type="text"
                    placeholder=" Last Name"
                    required
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>

              <div
                className="d-flex justify-content-between align-items-center gap-3"
                style={{ width: "100%" }}
              >
                <div style={{ flex: 1 }}>
                  <label className="lable2-for-new-client mt-1">
                    Choose Gender *
                  </label>

                  <div className="form-group-new-client">
                    <select
                      required
                      value={selectedGender}
                      onChange={handleGenderDataFromChild}
                      className="form-control"
                    >
                      <option> Select Gender</option>
                      <option value={1}> Male</option>
                      <option value={2}> Female</option>
                    </select>
                  </div>
                </div>

                {/* Date of Birth */}
                <div style={{ flex: 1 }}>
                  <label className="lable2-for-new-client ">
                    Date of Birth *
                  </label>

                  <DobWheelPicker
                    value={selectedDate}
                    onChange={setSelectedDate}
                    className="custom-date-input form-control dob-display-input"
                    style={{ position: "relative", bottom: 8 }}
                  />
                </div>
              </div>
              <div
                className="d-flex justify-content-between align-items-center gap-3"
                style={{ width: "100%" }}
              >
                <div style={{ flex: 1 }}>
                  <div className="lable2-for-new-client mt-1">
                    Select Country *
                  </div>

                  <div className="form-group-new-client">
                    <Select
                      options={countries}
                      placeholder="Select Country"
                      value={
                        countries.find((c) => c.value === countryCode) || null
                      }
                      onChange={(option) => setCountryCode(option.value)}
                      isSearchable
                      styles={customStyles}
                    />
                  </div>
                </div>
                {/* Phone Number */}
                <div style={{ flex: 1 }}>
                  <label className="lable2-for-new-client mt-1">
                    Enter Contact Number *
                  </label>

                  <div className="   form-group-new-client ">
                    <input
                      type="text"
                      placeholder="Enter Contact Number"
                      required
                      onChange={handlePhoneChange}
                      maxLength={15}
                      value={phno}
                      className="form-control"
                      disabled={profileId}
                    />
                  </div>
                </div>
              </div>
              {error && <p className="text-danger small mt-1">{error}</p>}

              <div className="background-section__row">
                <label
                  className="lable2-for-new-client"
                  htmlFor="relationshipHistory"
                >
                  Select State *
                </label>

                <Select
                  options={states}
                  placeholder="Select State"
                  value={selectedState}
                  onChange={(option) => setSelectedState(option)}
                  isDisabled={!countryCode}
                  isSearchable
                  styles={customStyles}
                />
              </div>
              <div className="background-section__row">
                <label
                  className="lable2-for-new-client"
                  htmlFor="relationshipHistory"
                >
                  Select City *
                </label>

                <Select
                  options={cities}
                  placeholder="Select City"
                  value={selectedCity}
                  onChange={(option) => setSelectedCity(option)}
                  isDisabled={!selectedState}
                  isSearchable
                  styles={customStyles}
                />
              </div>

              <div className="background-section__row">
                <label
                  className="lable2-for-new-client"
                  htmlFor="relationshipHistory"
                >
                  Relationship history *
                </label>
                <select
                  id="relationshipHistory"
                  className="background-section__input"
                  value={selectedMaritalStatus}
                  onChange={handleMaritaStatusDataFromChild}
                >
                  <option value="">Select Relationship history</option>
                  {renderRelations()}
                </select>
              </div>
              <div className="background-section__row">
                <label
                  className="lable2-for-new-client"
                  htmlFor="relationshipHistory"
                >
                  Profile Description *
                </label>
                <input
                  type="text"
                  value={desc}
                  className="background-section__input"
                  placeholder="EX: Family-oriented, emotionally mature, and professionally settled—seeking a life partner to grow with."
                  onChange={(e) => setDesc(e.target.value)}
                />
              </div>

              <div className="background-section__row">
                <label
                  className="lable2-for-new-client"
                  htmlFor="relationshipHistory"
                >
                  Select Community *
                </label>

                <select
                  name=""
                  id=""
                  className="background-section__input"
                  value={selectedCommunities}
                  onChange={handleCommunitiesDataFromChild}
                >
                  <option value="">Select Community</option>
                  {communityList?.map((comm) => (
                    <option key={comm.CommunitiesId} value={comm.CommunitiesId}>
                      {comm.CommunitiesName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="profile-match-limits">
                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Religion *</label>
                    <select
                      value={selectedReligion}
                      onChange={handleReligionDataFromChild}
                    >
                      <option>Select Religion</option>
                      {renderReligion()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                    <label>
                      <input
                        type="checkbox"
                        checked={limitSameReligion}
                        onChange={(e) => setLimitSameReligion(e.target.checked)}
                      />
                      Limit matches to same Religion
                    </label>
                  </div> */}
                </div>

                {/* <div className="field-pair">
                  <div className="select-block">
                    <label>Select Sect / Varna</label>
                    <select
                      required
                      value={selectedCaste}
                      onChange={handleCasteDataFromChild}
                    >
                      <option>Select Sect / Varna</option>
                      {renderCaste()}
                    </select>
                  </div>
                  <div className="checkbox-block">
                    <label>
                      <input type="checkbox" />
                      Limit matches to same Select Sect / Varna
                    </label>
                  </div>
                </div> */}
                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Catse *</label>
                    <select
                      value={selectedLevel2Caste}
                      onChange={handlelevle2Caste}
                      required
                    >
                      <option>Select Catse</option>
                      {renderLevel2Caste()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                    <label>
                      <input
                        type="checkbox"
                        checked={limitSameSubCaste}
                        onChange={(e) => setLimitSameSubCaste(e.target.checked)}
                      />
                      Limit matches to same Catse
                    </label>
                  </div> */}
                </div>
                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Sub Caste *</label>
                    <select
                      value={selectedLevel3Caste}
                      onChange={handleLevel3Caste}
                      required
                    >
                      <option>Select Sub Caste</option>
                      {renderLevel3Caste()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                    <label>
                      <input
                        type="checkbox"
                        checked={limitSameSubCommunity}
                        onChange={(e) =>
                          setLimitSameSubCommunity(e.target.checked)
                        }
                      />
                      Limit matches to same Sub Caste
                    </label>
                  </div> */}
                </div>

                <div className="field-pair">
                  <div className="select-block">
                    <label>Select Language *</label>
                    <select onChange={handleSelect}>
                      <option>Select Language</option>
                      {renderLang()}
                    </select>
                  </div>
                  {/* <div className="checkbox-block">
                    <label>
                      <input
                        type="checkbox"
                        checked={limitLanguage}
                        onChange={(e) => setLimitLanguage(e.target.checked)}
                      />
                      Limit matches to same language
                    </label>
                  </div> */}
                  {selectedLanguage.length > 0 && (
                    <div className="selected-forwred-client">
                      {selectedLanguage?.map((lang) => (
                        <span key={lang.LangId} className="tag">
                          {lang.LangDesc}
                          <button
                            className="click-effect"
                            onClick={() => removeLanguage(lang)}
                          >
                            X
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <>
            {/* <ClientInviteCard userData={UserDataMatchPrep} /> */}

            <BackgroundInfoSection
              dob={selectedDate}
              setDob={setSelectedDate}
              countryList={countryList}
              addresDet={addresDet}
              handelAddreesDet={handelAddreesDet}
              communityList={communityList}
              selectedResidence={selectedResidence}
              handleResidence={handleResidence}
              selectedCitizenship={selectedCitizenship}
              handleCitizenship={handleCitizenship}
              seletedEthinicity={seletedEthinicity}
              handleEthinicity={handleEthinicity}
              postalcode={postalcode}
              handlePostalcode={handlePostalcode}
            />

            <AddFamilyMemeberForClient
              familyDetails={familyDetails}
              setFamilyDetails={setFamilyDetails}
            />

            <AddFamilyWealthForClient
              familyWealth={familyWealth}
              setFamilyWealth={setFamilyWealth}
            />

            <EducationWorkForm
              qualifications={qualifications}
              handleQualificationDataFromChild={
                handleQualificationDataFromChild
              }
              selectedQualification={selectedQualification}
              collageName={collageName}
              setCollageName={setCollageName}
              jobRole={jobRole}
              setJobRole={setJobRole}
              Salary={Salary}
              setSalary={setSalary}
              carrerGoals={carrerGoals}
              setcarrerGoals={setcarrerGoals}
              salaryCurrency={salaryCurrency}
              setSalaryCurrency={setSalaryCurrency}
              allCountyMasterData={allCountyMasterData}
            />

            <PhysicalAttributesForm
              height={height}
              setHeight={setHeight}
              weight={weight}
              setWeight={setWeight}
              skinToneList={skinToneList}
              selectedSkinTone={selectedSkinTone}
              handelDataFromSkinToneModal={handelDataFromSkinToneModal}
              physicalbuildList={physicalbuildList}
              selectedBuild={selectedBuild}
              handelDataFromBuildModal={handelDataFromBuildModal}
            />

            <PhotographUploader
              profileImages={profileImages}
              setProfileImages={setProfileImages}
              otherMediaFiles={[videoFile, docFile]}
              accessOnRequest={accessOnRequest}
              setAccessOnRequest={setAccessOnRequest}
              mainIndex={mainIndex}
              setMainIndex={setMainIndex}
            />

            <LifestyleAndInterests
              habitList={habitList}
              selectedHabit={selectedHabit}
              setSelectedHabit={setSelectedHabit}
              hobbiesList={hobbiesList}
              selectedHobbies={selectedHobbies}
              setSelectedHobbie={setSelectedHobbie}
            />

            <VideoAndDocumentsUploader
              videoFile={videoFile}
              setVideoFile={setVideoFile}
              communitieDocs={communitieDocs}
              docFile={docFile}
              setDocFile={setDocFile}
              docName={docName}
              setDocName={setDocName}
              selectedReligion={selectedReligion}
              otherMediaFiles={[profileImages]}
            />
          </>
        )}

        {currentStep === 3 && UserDataMatchPrep && (
          <div className="profile-container">
            <ClientPreferences
              UserData={UserDataMatchPrep}
              preferencesSaveRef={preferencesSaveRef}
            />
          </div>
        )}

        <div className="button-row">
          {currentStep > 1 && (
            <button
              className="back-btn click-effect"
              onClick={() => setCurrentStep((prev) => prev - 1)}
            >
              Back
            </button>
          )}

          <button
            className="create-btn click-effect"
            onClick={handleNextStep}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : currentStep === 1 ? (
              "Create Profile"
            ) : currentStep === 3 ? (
              "Finish"
            ) : (
              "Next"
            )}
          </button>
        </div>
      </div>
      <div id="toast-message"></div>
    </div>
  );
}
